// store/slices/incomeExpenseReportSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

// ✅ GET /api/reports/income-report
export const fetchIncomeReportThunk = createAsyncThunk(
  "reports/incomeReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/reports/income-report", { params });
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

// ✅ GET /api/reports/expense-report
export const fetchExpenseReportThunk = createAsyncThunk(
  "reports/expenseReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/reports/expense-report", { params });
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const slice = createSlice({
  name: "incomeExpenseReport",
  initialState: {
    incomeRows: [],
    expenseRows: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearIncomeExpenseReport(state) {
      state.incomeRows = [];
      state.expenseRows = [];
      state.error = null;
    },
    clearIncomeReport(state) {
      state.incomeRows = [];
      state.error = null;
    },
    clearExpenseReport(state) {
      state.expenseRows = [];
      state.error = null;
    },
  },
  extraReducers: (b) => {
    b
      .addCase(fetchIncomeReportThunk.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchIncomeReportThunk.fulfilled, (s, a) => {
        s.loading = false;
        s.incomeRows = a.payload || [];
      })
      .addCase(fetchIncomeReportThunk.rejected, (s, a) => {
        s.loading = false;
        s.incomeRows = [];
        s.error = a.payload || "Failed to load income report";
      })

      .addCase(fetchExpenseReportThunk.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchExpenseReportThunk.fulfilled, (s, a) => {
        s.loading = false;
        s.expenseRows = a.payload || [];
      })
      .addCase(fetchExpenseReportThunk.rejected, (s, a) => {
        s.loading = false;
        s.expenseRows = [];
        s.error = a.payload || "Failed to load expense report";
      });
  },
});

export const { clearIncomeExpenseReport, clearIncomeReport, clearExpenseReport } =
  slice.actions;

export default slice.reducer;